import { useEntityUrl } from 'framework/routing';
import { RECONCILIATION_PATH } from 'domain/finance/costAccounting/reconcilation/useReconciliationService';

export const useReconcilationUrl = () => useEntityUrl({ baseLink: RECONCILIATION_PATH });
